import BrandEdit from './BrandEdit'

export default BrandEdit
